import moment from "moment";
import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import filterFactory from "react-bootstrap-table2-filter";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { NotificationManager } from "react-notifications";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Select from "react-select";
import { Loader } from "../../../components/loader";
import { BreadCrumb } from "../../../components/breadcrumb";

import {
  fetchVirtualVisitRequests,
  updateVirtualVistRequestStatus,
} from "../../../actions/virtualVisitRequest";
const $ = window.$;

const { SearchBar } = Search;

const toCapitalize = (name) => {
  if (name && name.length > 1) {
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  }
};

const PREFERRED_METHOD = {
  ZOOM : 'Zoom',
};

class VirtualVisitRequest extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      callAppointmentList: [],
      options: [
        { label: "Today", value: "today" },
        { label: "All Upcoming Calls", value: "all_upcoming" },
        { label: "All Past Calls", value: "all_past" },  
        { label: "Yesterday", value: "yesterday" },
        { label: "Tomorrow", value: "tomorrow" },
      ],
      search_by_date: "today",
      todayCallAppointments: [],
      yesterdayCallAppointments: [],
      tomorrowCallAppointments: [],
      upcomingCallAppointments: [],
      pastCallAppointments: [],
      statusOptions: [
        { label: "Completed", value: "completed" },
        { label: "Unattended", value: "unattended" },
        { label: "No Show", value: "no-show" },
      ],
      selectedStatus: "",
      currentStatus: "",
      selectedVRAppontmentDate: "",
      id: "",
      on_going_call: "",
    };
  }

  tableCallColumnData = [
    { dataField: "customer_name", text: "Customer Name", sort: true },
    {
      dataField: "pet_id",
      text: "Pet ID",
      sort: true,
      formatter: (cell, row) => {
        return (
          <span className="m-topbar__userpic">
            {row.MedicalRecord ? (
              <img
                src={
                  process.env.REACT_APP_S3_PATH +
                  "/" +
                  row.MedicalRecord.avatar_path +
                  "/" +
                  row.MedicalRecord.avatar_file_name
                }
                className="m--img-rounded m-width-50 mr-2"
                alt=""
              />
            ) : null}

            {row.pet_id_valid ? (
              <span className="m-badge m-badge--info mx-auto my-0 px-2">{cell}</span>
            ) : (
              <>
                <span className="m-badge m-badge--danger mx-auto my-0 px-2 mb-2">{cell}</span>
                <br />
                <span className="m--font-boldest">(Does Not Exist)</span>
              </>
            )}
          </span>
        );
      },
      headerStyle: (column, colIndex) => {
        return { width: "125px" };
      },
    },
    {
      dataField: "phone",
      text: "Phone Number",
      sort: true,
      formatter: (cell) => (
        <a href={`tel:${cell}`} className="hyperlink-phone-number">
          {cell}
        </a>
      ),
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
      headerStyle: (column, colIndex) => {
        return { width: "200px" };
      },
      formatter: (cell, row) => (
        <a
          href={`mailto:${cell}?body=Hello, ${toCapitalize(row.cus_firstname)}!`}
          className="hyperlink"
        >
          {cell}
        </a>
      ),
    },
    {
      dataField: "preferred_method",
      text: "Preferred Method",
      sort: true,
      headerStyle: (column, colIndex) => {
        return { width: "210px" };
      },
      formatter: (cell, row) => {
        return (
          <div className="m-demo-icon">
            <div
              style={{
                display: "table-cell",
                verticalAlign: "middle",
                padding: "0",
                textAlign: "left",
                paddingRight: "10px",
                width: "50px",
              }}
            >
              {cell.trim() === "WhatsApp Video Call" ? (
                <img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAAHAElEQVRIiaWXe1Ab1xXGv7sPraRdIQmQgEAA8YjAbxscJ+O2Tl9J6tg1SdppGjfBjcN46jaeZMbpZPpIt4kb19OJm0knZNpxm8mM3UzrOCWtsXE7wU2b2M3Q2sEGDIiXYYgRQgIJrR67q739Q0a1eLQw/f67e8+3v7tn7zl3l2CFkmWZUe1FBYbBFho6eJ7nxwNiYvJX+/ZpK7kPWU7Q91/+ze282bRb4Liv8zzntokSzbFZeZZhSWQ2qkUUhSaSybCu05Z4fPbNwwf39f5f4IM/e92dK9mPipL4hc3r1+RXe0pYQTAtGqvpKYyMjtOOzp5AaHrmUmw2uv/Qs03DKwb/+BfHv2axCK/cu+1ud0VZMTN33aAGFE2BkpwFAIiCBJGXwJBMCD6ZCOBs+4eTs7H4kef3P3p02eCfNJ/4aaHb9WTD9s/l8RwLABgM+tA9eQWDIR8SWjwr3sxbUOGsxtqCdajIq04v0DBw7vzF8ODI2BnV3/e4LMv6rR52PvRQ84kXvVWe7+y8b5uTZRj4oxNo6f4dLo7+HQHFD93Q51ugGzoCih/dk1dwfWYYBVIRbIIN1RWlZhBU3ogYte2tp95ZEiy/8uYOtyv/UMP99zgJIegN9OBk1wnMxKcXS8yiiiTCuDrxMRxmB9xSIYqL3HxoOly24dNf1NtPn7qwACy/ejzHYhHaHvvKAwUsy+JaoAvvdp+EQVPLhs7JoAb6p3qRJ7rgEt2oLC8RunsHN2zccv/bH7z37gwAZHYEz5GXPru13sXzHPzRCZzubQEFBQCYOTOqcitgM0nLhlNQtPa2YFLxg2EYbP/8Vrc919w8N88AgPzzNxyCWXjYW13BA8B7A2ehp9L9QOAEfOvOJjxR14hH1n11RU+upVT8uf80AKCowAWnw1733SO/9mbAGqW7Nqzy2gmAoaAP12dGMubPlG2FS8wHAHic5SiyFa4IPhYexVBoAACwef1ql81macyARat1r7eq3AIAXZNXsoyljtKs8ZaSzSsCA0CXvxMAUF5aTDiWaciAWYYps+dIMKiBwZAvyzS/fMycsGLwYMgHgxrgORaCYHLIsswxsiwzHM/yAKBo0QXNYWT6P2kPJyL4U9/ZFYMTWhyKpgAAbFYr0XI8BYzqKHaJVgsAQE
                                            lGF5g6xi8hpsUAAISQRRvIcjTXYnMcEqdpehEDajAMSXdOgxoLDDEthta+trRJsOHhVQ0gZFmHWrZuemjKoBxJ6YwpbJqOx5MAAKtJXNRz+UYnOsb/BQBYU7AKu2p2ZB0KAODNvwPSEn4AkEw2AEA4EtVVkvqEkeVvJhLJhAoAdsEB0xKb54/XWtE3ld54d5bUY2/dHhRIbgBAXfEmNG7cjWc/9Qx21mxHjpCT5bXwVoh8elGz0RgkxT/FAIBBcT0SVUAIQYWzclFwiqZw/OO30DmRLjePswwH7tqPpvonsKvmAQAAz/K4+/YteLKuMctblecFIQSJRBK6rvtlWTYYAIjG4sd6+oZiALCucOOS6UrRFH7f9Q7afH+BbugghMDjLAPHcFlxwXgoa7zavRYA4BseS6mqdgK4Wce8KfaHy1f7wpRSVORVo9B225JwSin+NvIBjn74Ki6OfYT4vPILxoI4038uMy53euDJTWexo7N7KhpTfwvcPJ3+euaMes99D96WY7PWu/NzWafZmek2SymhJ9E/5cOF0X9geHoEIzOj6Bj/J1r72qCo6ZrlWRMeWv0IRJMI38hY6lrf0KkXn378OABkcpTUtO64qhoAkDTU/wq9VbqhYyA0tOA6IQQ7ax+CS3RD03S0v//RZHRaPTg3nwFbLMKjlWUlAgCMhAaXDV5MPGvCjtoH4c2vBQXQ0nY+FEsknjr8vcbgXEy6GCklDGFqHDnpWhsKDcIlulFfche+5P0yCqSiZUPLnB40bmpCTf4qUEpx7vyFiN8faP7RU4+dujWOAMBzLx/buNZbdW7nvdtclFIoahSSYMsEUVAMBQdwdeIyBqcHoOrJLJiFt6Iy9w6sKViX
                                            2UiapuHt1vZgYCr4+g/27/7h/AVyACAJ5gZvZXk+kH43c9BAcBqzUQWe0mJU5lWjMq8aFBSRxAwUVQFLWIgmCaIggdz8YKUAevoG1PcvXgrEEvF9LxzY07pYZjgAYFiuoaykiERmoxgeHdf6BkaCU6GwSgm9nNJTN3jOtGvTeq+9tspjzbFJsJudsJudWTcKR2ZxzTcc7+zxhVU1+ZZmzDz/woFvLzx15lIty7+0puymgGgVpwGjP5ZMnDSSWtutfwHya69JKc3SYLVa9xKQcrNJMFusAqWUIhqLI6WlVEqNIUWJH2M5/rR84BuRpYAZ8HOHm51UsJQceWZPFwih/8sAALL8hlmxwsGbdPrS003+5Xjm69+mR9fgtLMRBgAAAABJRU5ErkJggg=="
                />
              ) : cell.trim() === PREFERRED_METHOD.ZOOM ? (
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAYAAAAe2bNZAAAABmJLR0QA/wD/AP+gvaeTAAADMklEQVRYhe2XS0hUURjH/9+5dx5YzahZtCl8jNh71UItpU1YBBYhSLsWoZnSKtBo2SJ6QCA4vWjVoieIaS9okQpK7ZKKspnRcNHTdNRsHGfO10LN+5q6Y3da9d99j3O+3z33nHO/C/xXBrUuOJ7jxDyU7oCC4EQJM/YJot1MKAZjNQA3gDiATwSEGPyQJDoiTb7BjMAUtU2US6IzAHakMX+vFNz8/oiv3xGY/Atj2eRVr4JRkwaEXozbpM7WRepzo0uGKWqLBiSJewA2LBlkUe9Y4erhet+btGEKL0WLWYp+ACsdAFnQV8GyLNzoD1kFhZUz0Drqk1K0OwwCAHkSojP/wli2bZiky32NgE0Og8yJsF541IvWIYPyg9FSguizijkpwbw93Ojr0/mMSQRxLtMgACAFnTbX1mh+0+ouqlOVHgibaB+nGNdfzmJ8hk2xirUKekeS+uKSS7QXo6qjlXTAWLd2gwuq5c6y1q4CFdV3p3/ZK9yEljI3ata7UHJ5SpfLJKoBnF+wdWUItMd+WWttXiWwZvncI1WuVfCoNgsHN7qs3zvxXq2pGsKFfwsDAF6FUFWo4GKV90+pW7XG4sowE4A1TsAAQI7X1kbLDbSyxwRTeGXMB8DlFIxdxbImlplgInU5E5hrA/6pvNO+7yYYEDGAj04VGYuZj7eFvoWO0YwZZk4RY3YsYWtSkx5HEjjU9QMfplKPJ+CF1jbA8APjgCfDSaPLtnpGkqi6NY0br2dhjURdWkt3tAVzuyQ6q/W1PI1h4LMLxbn2b77J+GLpqTjjZPcMHkUS5kSR7NShGeMFwckeABW2Ky9d3UNHV+zUOsyPS/I4kGJVnRNLwSeMThPMUIP/ORh3MkpCuGnVpFtuBLc3dpiBV5khwRshZhusQinv7PlmvB9AnoMoXxQlWRaqzw5bBVMekXCjP6QoyVIHV2gQ4IpUIL+FAYBQfXZYTcTLAdzC0jc1M+GG2xPbNnTU9/Z3ibbby/xgtJRInAGjMg2QbpayebjJ/8xOctq9blFbNCCh7J9vjLZA/zszSsAAE90XMtmR6v/IMRijAq3siavRLHfCP6396P2Xk/oJS18HvpdNa2cAAAAASUVORK5CYII=" />
              ) : cell.trim() === "FaceTime Call" ? (
                <img
                  alt="svgImg"
                  src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHg9IjBweCIgeT0iMHB4Igp3aWR0aD0iMzUiIGhlaWdodD0iMzUiCnZpZXdCb3g9IjAgMCA0OCA0OCIKc3R5bGU9IiBmaWxsOiMwMDAwMDA7Ij48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMjUuOCwxNS42SDE0LjJjLTIsMC0zLjcsMS43LTMuNywzLjd2OS41YzAsMiwxLjcsMy43LDMuNywzLjdoMTEuNmMyLDAsMy43LTEuNywzLjctMy43di05LjUJQzI5LjUsMTcuMiwyNy44LDE1LjYsMjUuOCwxNS42eiI+PC9wYXRoPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0zNC45LDE2LjRMMzEsMTkuOGMtMC4yLDAuMi0wLjQsMC41LTAuNCwwLjh2Ni43YzAsMC4zLDAuMSwwLjYsMC40LDAuOGwzLjksMy41YzAuOSwwLjgsMi40LDAuMiwyLjQtMS4xVjE3LjUJQzM3LjMsMTYuMiwzNS45LDE1LjUsMzQuOSwxNi40eiI+PC9wYXRoPjxwYXRoIGZpbGw9IiMwZjAiIGQ9Ik0zNSw2SDEzYy0zLjksMC03LDMuMS03LDd2MjJjMCwzLjksMy4xLDcsNyw3aDIyYzMuOSwwLDctMy4xLDctN1YxM0M0Miw5LjEsMzguOSw2LDM1LDZ6IE0yOSwyOC41CWMwLDEuOS0xLjYsMy41LTMuNSwzLjVoLTExYy0xLjksMC0zLjUtMS42LTMuNS0zLjV2LTljMC0xLjksMS42LTMuNSwzLjUtMy41aDExYzEuOSwwLDMuNSwxLjYsMy41LDMuNVYyOC41eiBNMzcsMjkuOQljMCwxLjEtMS4zLDEuNy0yLjIsMWwtMy41LTMuMUMzMS4xLDI3LjYsMzEsMjcuMywzMSwyN3YtNmMwLTAuMywwLjEtMC42LDAuMy0wLjdsMy41LTMuMWMwLjgtMC43LDIuMi0wLjIsMi4yLDFWMjkuOXoiPjwvcGF0aD48L3N2Zz4="
                />
              ) : (
                ""
              )}
            </div>
            <div className="m-demo-icon__class">{cell}</div>
          </div>
        );
      },
    },
    {
      dataField: "appointment_date",
      type: "date",
      text: "Appointment Date",
      formatter: (cell) => moment(cell).format("MM-DD-YYYY"),
      sort: true,
    },
    {
      text: "Time",
      sort: true,
      headerStyle: (column, colIndex) => {
        return { width: "150px" };
      },
      formatter: (cell, row) => {
        return (
          <span>
            {row.start_time} - {row.end_time}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      sort: true,
      headerStyle: (column, colIndex) => {
        return { width: "120px" };
      },
      formatter: (cell, row) => (
        <>
          <span
            onClick={(e) => {
              this.openStatusEditModal(e, row);
            }}
            style={{ cursor: "pointer" }}
            className={
              "m-badge mx-auto my-0 px-2 mb-2 " +
              (cell === "canceled" || cell === "unattended" || cell === "no-show"
                ? " m-badge--danger"
                : cell === "active" && row.on_going
                ? " m-badge--warning"
                : " m-badge--success")
            }
          >
            {cell === "active" && row.on_going
              ? "Ongoing"
              : cell === "active" && !row.on_going
              ? "Upcoming"
              : cell}
            <i className="la 	la-caret-down ml-2"></i>
          </span>
        </>
      ),
    },
  ];

  openStatusEditModal = (event, record) => {
    event.preventDefault();
    this.setState(
      {
        id: record.id,
        currentStatus: record.status,
        selectedVRAppontmentDate: record.appointment_date,
        on_going_call: record.on_going ? true : false,
      },
      () => {
        $("#edit_virtual_request_status_modal").modal("show");
      }
    );
  };

  changeVRStatus = (selected) => {
    if (selected && selected.value) {
      this.setState({
        selectedStatus: selected.value,
      });
    }
  };

  updateStatus = () => {
    if (
      moment(this.state.selectedVRAppontmentDate).isSameOrAfter(moment()) ||
      this.state.on_going_call
    ) {
      NotificationManager.warning(`Cannot update upcoming or ongoing call status`);
    } else if (this.state.currentStatus === "canceled") {
      NotificationManager.warning(`Cannot update canceled call status`);
    } else {
      this.props.updateVirtualVistRequestStatus(this.state.id, this.state.selectedStatus);
    }
  };

  componentDidMount() {
    this.props.fetchVirtualVisitRequests();
  }

  refreshVirtualCallRequests = () => {
    this.setState({ loading : true });
    this.props.fetchVirtualVisitRequests();
  };

  componentWillReceiveProps = (nextProps) => {
    if (
      nextProps.callAppointmentList &&
      nextProps.callAppointmentList !== this.props.callAppointmentList
    ) {
      this.setState({ callAppointmentList: nextProps.callAppointmentList });

      let upcomingCallAppointments = [];
      let pastCallAppointments = [];
      let todayCallAppointments = [];
      let yesterdayCallAppointments = [];
      let tomorrowCallAppointments = [];

      for (var i = 0; i < nextProps.callAppointmentList.length; i++) {
        let appointment = nextProps.callAppointmentList[i];
        const today = moment().format("YYYY-MM-DD");
        const appointment_date = moment(appointment.appointment_date).format("YYYY-MM-DD");
        const startTime = moment(appointment.start_time,["h:mm A"]).format("HH:mm");
        const endTime = moment(appointment.end_time,["h:mm A"]).format("HH:mm");
        const currentTime = moment().format("HH:mm");

        if (moment(appointment_date).isAfter(today)) {
          upcomingCallAppointments.push(appointment);
        }

        if (moment(today).isAfter(appointment_date)) {
          pastCallAppointments.push(appointment);
        }

        if (appointment_date == today) {
          todayCallAppointments.push(appointment);
          if(startTime > currentTime){
            upcomingCallAppointments.push(appointment);       
          }        
          else if (
            startTime <= currentTime && endTime >= currentTime ) {
            appointment.on_going = true;         
          }    
    
        } else if (moment(today).diff(appointment_date, "days") == 1) {
          yesterdayCallAppointments.push(appointment);
        } else if (moment(appointment_date).diff(today, "days") == 1) {
          tomorrowCallAppointments.push(appointment);
        }

        upcomingCallAppointments.sort(function (a, b) {
          var c = new Date(a.appointment_date);
          var d = new Date(b.appointment_date);
          return c - d;
        });
      }

      this.setState({
        upcomingCallAppointments: upcomingCallAppointments,
        pastCallAppointments: pastCallAppointments,
        todayCallAppointments: todayCallAppointments,
        yesterdayCallAppointments: yesterdayCallAppointments,
        tomorrowCallAppointments: tomorrowCallAppointments,
        loading : false
      });

      NotificationManager.success(`Virtual visit requests refreshed successfully`);
    }

    if (
      nextProps.virtualVisitRequestStatusUpdated &&
      nextProps.virtualVisitRequestStatusUpdated !== this.props.virtualVisitRequestStatusUpdated
    ) {
      NotificationManager.success(`Virtual visit request status updated successfully`);
      $("#edit_virtual_request_status_modal").modal("hide");
      this.props.fetchVirtualVisitRequests();
    }

    if( nextProps.virtualVisitRequestsError !== this.props.virtualVisitRequestsError ){
      NotificationManager.error("An error occurred while loading the virtual visits");
      this.setState({ loading : false }); 
    }
  };
  items = [{ title: "Virtual Visit Requests", to: "/virtual-visit-requests" }];

  filterByDate = (selected) => {
    if (selected && selected.value) {
      this.setState({ search_by_date: selected.value });
    }
  };

  render() {
    const {
      loading,
      options,
      search_by_date,
      upcomingCallAppointments,
      statusOptions,
      selectedStatus,
      currentStatus,
      on_going_call,
    } = this.state;
    return (
      <div className="m-grid m-grid--hor m-grid--root m-page">
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
          <BreadCrumb items={this.items} />
          <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
            <div className="m-grid__item m-grid__item--fluid m-wrapper">
              <div className="m-portlet m-portlet--mobile">
                <div className="m-portlet__head">
                  <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                      <div className="col">
                        <h3 className="mt-4 mb-0">Virtual Visit Requests</h3>
                      </div>
                    </div>
                  </div>
                  <div className="m-portlet__head-tools">
                    <ul className="m-portlet__nav">
                      <li className="m-portlet__nav-item">
                        <a
                          href="#"
                          className="btn btn-accent m-btn m-btn--custom m-btn--pill m-btn--icon m-btn--air"
                          onClick={this.refreshVirtualCallRequests}
                        >
                          <span>
                            <i className="la la-refresh"></i>
                            <span>Refresh</span>
                          </span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="m-portlet__body">
                  {/* <SearchBarButton/> */}
                { !this.state.loading ?                  
                  <ToolkitProvider
                    keyField="id"
                    data={
                      search_by_date == "today"
                        ? this.state.todayCallAppointments
                        : search_by_date == "yesterday"
                        ? this.state.yesterdayCallAppointments
                        : search_by_date == "tomorrow"
                        ? this.state.tomorrowCallAppointments
                        : search_by_date == "all_past"
                        ? this.state.pastCallAppointments
                        : upcomingCallAppointments
                    }
                    columns={this.tableCallColumnData}
                    filter={filterFactory()}
                    search
                    defaultSortDirection="asc"
                    hover={true}
                  >
                    {(props) => (
                      <div>
                        <div className="px-0 mb-4 search-bar">
                          <div className="col-lg-5">
                            <div className="row">
                              <div className="col-lg-3 col-xs-3 col-md-3 mt-2 ">
                                <h5>Date Filter</h5>
                              </div>
                              <div className="col-lg-8 col-xs-8 col-md-8 pl-0 ml-0">
                                <Select
                                  options={options}
                                  value={search_by_date}
                                  name="search_by_date"
                                  onChange={this.filterByDate}
                                  placeholder="Select the Timeline"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-4 p-0 m-0"></div>
                          <div className="col-lg-3 px-0 inner-addon right-addon">
                            <i className="fas fa-search"></i>
                            <SearchBar {...props.searchProps} placeholder="Search All" />
                          </div>
                        </div>
                        <BootstrapTable
                          classes="petTable"
                          {...props.baseProps}
                          hover
                          striped
                          pagination={paginationFactory()}
                        />
                      </div>
                    )}
                  </ToolkitProvider>:
                  <div className="center-row" >
                    <Loader size={50} />  
                  </div>
                }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="edit_virtual_request_status_modal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby=""
          aria-hidden="true"
        >
          <div className="modal-dialog modal-sm" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Edit Virtual Request Status
                </h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="form-group m-form__group  row mb-0 ">
                  <label className="col-6 mr-0 pr-0">Current Status &nbsp; &nbsp; &nbsp; : </label>
                  <div className="col-6 ml-0 pl-0">
                    <span
                      className={
                        "m-badge mx-auto my-0 px-2 mb-2 " +
                        (currentStatus === "canceled" ||
                        currentStatus === "unattended" ||
                        currentStatus === "no-show"
                          ? " m-badge--danger"
                          : currentStatus == "active" && on_going_call
                          ? " m-badge--warning"
                          : " m-badge--success")
                      }
                    >
                      {currentStatus == "active" && on_going_call
                        ? "Ongoing"
                        : currentStatus == "active" && !on_going_call
                        ? "Upcoming"
                        : currentStatus}
                    </span>
                  </div>
                </div>
                <div className="form-group m-form__group row mb-0 mt-3">
                  <div className="col-lg-12">
                    <Select
                      options={statusOptions}
                      value={selectedStatus}
                      name="status"
                      onChange={this.changeVRStatus}
                      placeholder="Select The Status"
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <div>
                  <button
                    type="button"
                    className="btn btn-secondary m-btn--pill mx-2"
                    data-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    onClick={this.updateStatus}
                    className="btn btn-primary m-btn--pill"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  callAppointmentList: state.virtualVisitRequestReducer.virtualVisitRequests,
  virtualVisitRequestStatusUpdated: state.virtualVisitRequestReducer.virtualVisitRequestStatusUpdated,
  virtualVisitRequestsError : state.virtualVisitRequestReducer.virtualVisitRequestsError
});

const mapDispatchToProps = (dispatch) => ({
  fetchVirtualVisitRequests: () => {
    dispatch(fetchVirtualVisitRequests());
  },
  updateVirtualVistRequestStatus: (id, status) => {
    dispatch(updateVirtualVistRequestStatus(id, status));
  },
});

VirtualVisitRequest = connect(mapStateToProps, mapDispatchToProps)(VirtualVisitRequest);

export default withRouter(VirtualVisitRequest);
